/**
 * index.js
 * Appel tous les composantes
 */

// Ordre alphabétique
export * from './accordions/accordions';
export * from './actualites/actualites';
export * from './babillard/babillard';
export * from './banniere/banniere';
export * from './breadcrumb/breadcrumb';
export * from './customClass/customClass';
export * from './employe/employe';
export * from './evenements/evenements';
export * from './filtre/filtre';
export * from './footer/footer-uqam';
export * from './gutenberg/gutenberg';
export * from './header/header-uqam';
export * from './liensPlus/liensPlus';
export * from './menuHorizontal/menuHorizontal';
export * from './menuMain/menuMain';
export * from './menuMobile/menuMobile';
export * from './menuUsers/menuUsers';
export * from './ninjaForm/ninjaForm';
export * from './pagination/pagination';
export * from './recherche/recherche';
export * from './retourHautPage/retourHautPage';
export * from './tableau/tableau';
export * from './service/service';
export * from './shame/shame';
export * from './sidebarPromo/sidebarPromo';
export * from './sidebarSocialMedia/sidebarSocialMedia';
export * from './titre/titre';
export * from './woocommerce/woocommerce';